import { useLocation, useNavigate } from "react-router-dom";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { UseAuth } from "../auth/AuthContext";
import NavUser from "../components/System/NavUser";
import Sidebar, { MenuListedClient } from "../components/System/Sidebar";
import logoISF from "src/assets/images/logo/BannerISFsmall.png"
import { getLogout } from "src/helpers/mixins";
import LoadingScreen from "src/components/LoadingScreen";
import { useAppStateContext } from "src/auth/AppStateContext";
import { IoClose } from "react-icons/io5";
import OfflineAlert from "src/components/Shared/OfflineAlert";
import LastConnection from "src/components/Shared/LastConnection";
import VersionCheck from "src/components/Shared/VersionCheck";
import GetMyCashierFather from "src/components/GetMyCashierFather";
 
const WelcomeSetName = lazy(
  () => import("src/components/Welcome/WelcomeSetName")
);
 
 

interface LayoutOptions {
  children: React.ReactElement;
}

const Layout = ({ children }: LayoutOptions) => {
  const { isAuthenticated, user } = UseAuth();
  //const token = localStorage.getItem('authToken')
  const navigate = useNavigate();
  const { showMenuMovil,setShowMenuMovil} = useAppStateContext()
  const [showMenu, setShowMenu] = useState(true);
  const [countedFetched, setCountedFetched] = useState(0)
  /* const [showName, setShowName] = useState(false) */
/*   const toggleMenu = () => {
    setShowMenu(!showMenu);
  }; */
  const { pathname } = useLocation();
  
 
  useEffect(() => {
    setShowMenu(false);
  }, [pathname]);

  useEffect(() => {
    if (showMenu) {
      window.scrollTo(0, 0);
    }
  }, [showMenu]);

 

  useEffect(() => {
    // 60 seg * 10 = 600 seg => 10 min
    /*60 * 10*/
    const TIME_INACTIVO = 2400;
    let n = TIME_INACTIVO;
    const interval = setInterval(() => {
      window.onmousemove = function () {
        n = TIME_INACTIVO;
      };
      n--;
      if (n < 0) {
        getLogout();
        navigate("/");
        return () => clearInterval(interval);
      }
    }, 1000);
    //console.log('n', n)
    return () => clearInterval(interval);
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if(user?.role === 'admin'){
      navigate('/admin')
    }
  }, [user])
  
  return (
    <div className="min-h-screen  w-full bg-gray-100 text-gray-800">

        <OfflineAlert />
        <VersionCheck />


      {isAuthenticated && <LastConnection />}
      <NavUser />
      <div className="w-full md:w-11/12 md:mx-auto flex flex-row md:gap-4 flex-grow overflow-hidden mt-5">

      <div className='w-full absolute md:w-72 md:relative' style={{zIndex:""}}>
          <Sidebar closeMenu={() => setShowMenu(false)} showMenu={showMenu} />
        </div>

      
      
        {!showMenuMovil && (
          <div className="w-full md:w-11/12 px-2 md:px-6 py-2 mx-auto mt-0 mb-32 rounded-md">
            {children}
          </div>
        )}
        {showMenuMovil &&   
          <div className='bg-nav-movil-cashier-user flex flex-col justify-center items-center pt-2'>
            <div className='w-full flex items-center z-20 justify-between  px-4 border-b border-stone-300 fixed top-0 bg-white'>
              <img src={logoISF} 
              className='w-10'
              alt="ISF" 
              />
              <div className='cursor-pointer' onClick={() => setShowMenuMovil(false)}>
                <IoClose size={45} />
              </div>
            </div>
            <div className='listed-in-movil  w-full md:w-fit z-10 relative'>
              <MenuListedClient size="sm" close={() => setShowMenuMovil(false)} />
            </div>
          </div>
        }
        {/*<div>
          {(user?.role || "client") === "admin" ? <ChatAdmin /> : <ChatClient />}
        </div> */}
      </div>

      <Suspense fallback={<LoadingScreen />}>
        {user?.fullname?.toLowerCase().includes(user?.email?.toLowerCase()) && (
          <WelcomeSetName />
      )}
        </Suspense>
      <GetMyCashierFather setCashier={() => null} />
    </div>
  );
};

export default Layout;
